import { InspectionTemplatesData } from "@/shared/models/Inspection";
import { getInspectionTemplates } from "@/shared/repositories/InspectionTemplateRepository";
import { useQuery } from "@tanstack/react-query";

export const useInspectionTemplateCatalog = (
	onError?: (error: Error) => void,
) =>
	useQuery<InspectionTemplatesData, Error>({
		queryKey: ["inspection-templates", true],
		queryFn: ({ signal }) =>
			getInspectionTemplates({ includeInactive: true }, signal),
		onError,
	});
